import React from "react";
import { Card, CardContent } from "../../shadcn/components/ui/card";
import PageHeader from "../../Components/Common/PageHeader";

const BillingPageLayout = React.forwardRef(function BillingPageLayout(
  { title, subtitle, children },
  ref
) {
  return (
    <main ref={ref} className="box-border w-full min-w-0 grow p-4 text-sm text-foreground min-[900px]:p-6">
      <PageHeader title={title} subtitle={subtitle} bordered={false} />
      <Card className="w-full max-w-3xl">
        <CardContent className="flex min-w-0 flex-col gap-6">
          {children}
        </CardContent>
      </Card>
    </main>
  );
});

export default BillingPageLayout;
